<template>
  <v-chip
    label
    color="blue-darken-3"
    theme="dark"
    class="px-1"
    :size="isDense ? 'x-small' : 'small'"
    v-bind="$attrs"
  >
    <base-picture-company-avatar
      v-if="company && company.logo"
      :src="(company.logo) ? company.logo : ''"
      class="mr-1"
      :width="(isDense) ? 16 : 22"
      :height="(isDense) ? 16 : 22"
    ></base-picture-company-avatar>
    <span
      v-if="company && company.name"
    >{{ (company.name.length > maxLength) ? company.name.substring(0, (maxLength - 2)) + "..." : company.name }}</span>
    <v-icon
      v-if="company"
      class="ml-1"
      :size="isDense ? 'x-small' : 'small'"
    >mdi-linkedin</v-icon>
  </v-chip>
</template>

<script>
export default {
  name: 'BaseLinkedinCompany',

  inheritAttrs: false,

  props: {
    modelValue: {
      type: Object,
      default: null,
    },
    value: {
      type: Object,
      default: null,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    density: {
      type: String,
      default: undefined,
    },
    narrow: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['update:modelValue', 'input'],

  computed: {
    company() {
      return this.modelValue ?? this.value;
    },
    isDense() {
      return this.dense || this.density === 'compact';
    },
    maxLength: function () {
      return (this.narrow) ? 20 : 25;
    },
  },

  watch: {
    company() {
      this.$emit('update:modelValue', this.company);
      this.$emit('input', this.company);
    },
  },
};
</script>
